/* eslint-disable */
import { useDataContext } from '../context';
import React, { useEffect } from 'react';

function AllDepartment() {
  const { data, setData } = useDataContext();

  // useEffect(() => {
  //   const fetchData = () => {
  //     const myHeaders = new Headers();
  //     myHeaders.append("Authorization", "Basic SHJAYm9vbnNpcmkuY28udGg6SHJAYnNyISEh");

  //     const requestOptions = {
  //       method: "GET",
  //       headers: myHeaders,
  //       redirect: "follow"
  //     };
      
  //     fetch("https://api-hr.boonsiri.co.th/resignations", requestOptions)
  //       .then((response) => response.json())
  //       .then((result) => {
  //         setData(prevData => ({...prevData, resignations: result.data||[]}));
  //       })
  //       .catch((error) => console.error(error));
  //   };

  //   // เรียก fetchData ทันทีที่ component mount
  //   fetchData();

  //   // ตั้ง interval เพื่อเรียก fetchData ทุก ๆ 5 วินาที
  //   

  //   // ทำการ cleanup interval เมื่อ component ถูก unmount
  //   
  // }, [setData]);

  return null;
}

export default AllDepartment;
